import React, { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

/**
 * BackToTopFAB — Mobile-only floating button that appears after the user has
 * scrolled past the threshold. Tapping it smoothly scrolls back to the top.
 * Hidden on md+ where the page footer / sidebar already give a quick way back.
 */
export default function BackToTopFAB({ threshold = 360 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="Volver arriba"
      data-testid="back-to-top-fab"
      className={`md:hidden fixed right-5 z-40 grid place-items-center w-12 h-12 rounded-full bg-velcor-green text-white shadow-lg shadow-velcor-green/30 ring-2 ring-white transition-all duration-200 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
      style={{
        // Stack above the floating ChatWidget bubble (48px + 16px safe-area + 10px gap)
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 74px)",
      }}
    >
      <ChevronUp className="w-5 h-5" strokeWidth={2.6} />
    </button>
  );
}
